export default __webpack_public_path__ + "static/form-required-field-do-87c32641a850acbe87f0f155d4937ce2.png";